module.exports = __webpack_public_path__ + "c70350bfc2e652ce59d11d596d10de08.svg";